import axios from "axios";
import Swal from "sweetalert2";
import {
  baseUrl,
  defaultAddErrorMessage,
  defaultUpdateErrorMessage,
  errorTranslate,
  objectifyForDropdown,
} from "../util";

export const addEconomicSupplierToBusiness = ({
  businessId,
  account_name,
  facility,
  facility_id,
  category,
  subcategory,
  is_manuel,
  manuel,
  emission_factor,
  year,
  loading = null,
  setLoading = null,
  index,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    account_name: account_name,
    facility: facility,
    category: category,
    subcategory: subcategory,
    is_manuel: is_manuel,
    manuel: manuel,
    emission_factor: emission_factor,
    facility_id: facility_id,
    year: year,
  });

  var config = {
    method: "post",
    url: baseUrl + "/api/business/" + businessId + "/economic-supplier",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal) {
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      setErrorMessage(error.response.data);
      if (loading) setLoading("failed");
      if (use_swal) {
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultAddErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      }
    });
};

export const deleteEconomicSupplier = ({
  businessId,
  objectId,
  use_swal = false,
  loading = null,
  setLoading = null,
  callback,
}) => {
  var config = {
    method: "delete",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/economic-supplier/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");
      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
    });
};

export const getEconomicSupplierList = ({
  businessId,
  objectId,
  objects,
  setObjects = function () {
    return;
  },
  setCategorizedData = function () {
    return;
  },
  category,
  facilityId,
}) => {
  var config = {
    method: "get",
    url: baseUrl + "/api/business/" + businessId + "/economic-supplier",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    params: {
      facility_id: facilityId,
    },
  };

  axios(config)
    .then(function (response) {
      if (category && facilityId) {
        setCategorizedData(
          response.data.data.filter((data) => {
            return (
              data.facility_id === facilityId && data.category === category
            );
          })
        );

        setObjects(
          response.data.data
            .filter((data) => {
              return (
                data.facility_id === facilityId && data.category === category
              );
            })
            .map((data) => {
              return data;
            })
        );
      } else {
        // If no category or facilityId is provided, process all data
        setObjects(
          response.data.data.map((data) => {
            // data.facility = objectifyForDropdown(data.facility);
            // data.category = objectifyForDropdown(data.category);
            // data.subcategory = objectifyForDropdown(data.subcategory);
            // data.emission_factor = objectifyForDropdown(data.emission_factor);
            // data.is_manuel = data.is_manuel ? "Yes" : "No";
            return data;
          })
        );
      }
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};

export const updateEconomicSupplier = ({
  businessId,
  objectId,
  account_name,
  account_number,
  amount,
  facility,
  facility_id,
  category,
  subcategory,
  is_manuel,
  manuel,
  emission_factor,
  subcategory_key,
  period,
  entry_number,
  text,
  invoice_date,
  typedb,
  objects,
  setObjects = function () {
    return;
  },
  loading = null,
  setLoading = null,
  use_swal = false,
  callback = null,
  setErrorMessage = function () {
    return;
  },
}) => {
  var data = JSON.stringify({
    account_name: account_name,
    account_number: account_number,
    amount: amount,
    facility: facility,
    facility_id: facility_id,
    category: category,
    subcategory: subcategory,
    is_manuel: is_manuel,
    manuel: manuel,
    emission_factor: emission_factor,
    business: businessId,
    subcategory_key: subcategory_key,
    typedb: typedb,
    period: period,
    entry_number: entry_number,
    text: text,
    invoice_date: invoice_date,
  });

  var config = {
    method: "put",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/economic-supplier/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
    data: data,
  };
  if (loading) setLoading("load");

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          if (response.data.data.id === supply.id) {
            return response.data.data;
          }
          response.data.data.facility = objectifyForDropdown(
            response.data.data.facility
          );
          response.data.data.category = objectifyForDropdown(
            response.data.data.category
          );
          response.data.data.subcategory = objectifyForDropdown(
            response.data.data.subcategory
          );
          response.data.data.emission_factor = objectifyForDropdown(
            response.data.data.emission_factor
          );
          return supply;
        })
      );
      if (use_swal)
        Swal.fire({
          title: "Success!",
          icon: "success",
          // text: error,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      if (loading) setLoading("success");
      if (callback) callback();
      setErrorMessage();
    })
    .catch(function (error) {
      console.log(error);
      if (loading) setLoading("failed");

      if (use_swal)
        Swal.fire({
          title: errorTranslate(),
          icon: "error",
          text: defaultUpdateErrorMessage,
          confirmButtonColor: "#a9c1b4",
          // width: 600,
          // padding: '3em',
          color: "#476355",
          background: "#f1f8ef",
        });
      setErrorMessage(error.response.data);
    });
};

export const getEconomicSupplier = ({
  businessId,
  objectId,
  objects,
  setObjects,
}) => {
  var config = {
    method: "get",
    url:
      baseUrl +
      "/api/business/" +
      businessId +
      "/economic-supplier/" +
      objectId,
    headers: {
      Authorization: "Bearer " + localStorage.getItem("access_token"),
      "Content-Type": "application/json",
    },
  };

  axios(config)
    .then(function (response) {
      setObjects(
        objects.map((supply) => {
          const gotValue = response.data.data;

          if (gotValue.id === supply.id) {
            gotValue.facility = objectifyForDropdown(gotValue.facility);
            gotValue.category = objectifyForDropdown(gotValue.category);
            gotValue.subcategory = objectifyForDropdown(gotValue.subcategory);
            gotValue.emission_factor = objectifyForDropdown(
              gotValue.emission_factor
            );
            gotValue.is_manuel = gotValue.is_manuel ? "Yes" : "No";
            return gotValue;
          }
          return supply;
        })
      );
    })
    .catch(function (error) {
      console.log(error);
      // setLoading(false)
      // Swal.fire({
      //   title: errorTranslate(),
      //   icon: 'error',
      //   text: error,
      //   confirmButtonColor: '#a9c1b4',
      //   // width: 600,
      //   // padding: '3em',
      //   color: '#476355',
      //   background: '#f1f8ef',
      // })
    });
};
